import React, { useEffect, useState } from "react";
import { Box, Grid, Avatar, IconButton, Typography, Menu, MenuItem, ListItemIcon, Tooltip, Link } from "@mui/material";
import "common/scss/styles.scss";
import logo from "assets/logo/Sage2.0-logo-svg.svg";
import { useAppDispatch, useAppSelector } from "store/hooks";
import MenuIcon from "@mui/icons-material/Menu";
import { MenuItems } from "./MenuItems";
import { useLocation, useNavigate } from "react-router";
import "./header.scss";
import localStorageMethods from "helpers/localStorage";
import { publicPaths } from "router/paths";
import { signOutAction } from "features/authDashboard/actions/signOut.action";
import { resetSavedTransactionLogsSearchFilter } from "features/adminDashboard/slices/saveTimeDropdownSelection.slice";

const Header = () => {
  const [userName, setUserName] = useState<string>("");
  const isMobileTablet = useAppSelector((state) => state?.deviceDetection?.isMobileTabletDevice);
  const [anchorElMobileMenu, setAnchorElMobileMenu] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorElMobileMenu);
  const menu = MenuItems;
  const currentLocation = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const username = localStorageMethods.getItemFromLocalStorage("username");

  useEffect(() => {
    const name = JSON.parse(localStorage.getItem("username"));
    setUserName(name?.split("@"));
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMobileMenu(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElMobileMenu(null);
  };

  const onListItemClick = (itemTitle) => {
    setAnchorElMobileMenu(null);
    setTimeout(() => {
      navigate(itemTitle.path);
    }, 500);
  };

  const handleLogOut = () => {
    localStorageMethods.emptyLocalStorage();
    navigate(publicPaths.home);
    dispatch(signOutAction(username));
    dispatch(resetSavedTransactionLogsSearchFilter());
  };

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
      <Grid container className="header-container">
        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
          {isMobileTablet ? (
            <Grid container>
              <Grid item sx={{ alignSelf: "center" }}>
                <IconButton onClick={handleClick} sx={{ alignSelf: "center", p: 0 }}>
                  <MenuIcon fontSize="large" />
                </IconButton>
              </Grid>
              <Grid item>
                <img src={logo} width={140} height={40} />
              </Grid>
            </Grid>
          ) : null}
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorElMobileMenu}
            open={open}
            onClose={handleClose}
          >
            {menu.map((menuItem) => (
              <MenuItem
                key={menuItem.name}
                className={menuItem.path === currentLocation.pathname ? "menu-selected" : "menu-not-selected"}
                onClick={() => onListItemClick(menuItem)}
              >
                <ListItemIcon className={menuItem.path === currentLocation.pathname ? "menu-selected" : "menu-not-selected"}>
                  {menuItem.icon}
                </ListItemIcon>
                <Typography>{menuItem.name}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4} sx={{ textAlign: "right", alignSelf: "center" }}>
          <Tooltip title={userName[0] || ""}>
            <IconButton sx={{ pt: 0, pb: 0 }}>
              <Typography sx={{ pr: 1 }}>{!isMobileTablet ? `Hi, ${userName[0]}` : null}</Typography>
              <Avatar alt="user icon" />
            </IconButton>
          </Tooltip>
          {isMobileTablet ? (
            // <IconButton color="error" onClick={handleLogOut} sx={{ textAlign: "right", alignSelf: "center" }}>
            //   <LogoutIcon fontSize="large" />
            // </IconButton>
            // <Typography color="error">Logout</Typography>
            <Link onClick={handleLogOut} color="error">
              Logout
            </Link>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
